module.exports = __webpack_public_path__ + "img/index1.15dfac04.png";